
















































import Vue from "vue";
import WizardTab from "../../../components/black_dashboard_pro/Wizard/WizardTab.vue";
import SimpleWizard from "../../../components/black_dashboard_pro/Wizard/Wizard.vue";
import CreateInvoicesForm from "./wizard/CreateInvoicesForm.vue";
import CreateInvoicesLines from "./wizard/CreateInvoicesLines.vue";
import CreateInvoicesFormFinal from "./wizard/CreateInvoicesFormFinal.vue";
import { ValidationObserver } from "vee-validate";
import Invoice from "../../../types/invoices/Invoice";
import InvoiceLine from "../../../types/invoices/InvoiceLine";
import currency from "currency.js";
export default Vue.extend({
  name: "create-invoices-page",
  components: {
    //@ts-ignore
    SimpleWizard,
    //@ts-ignore
    WizardTab,
    CreateInvoicesForm,
    CreateInvoicesLines,
    CreateInvoicesFormFinal,
  },
  data() {
    return {
      invoiceData: {} as Invoice,
      receiver: null,
    };
  },
  computed: {
    getInvoiceData(): Invoice {
      return this.invoiceData;
    },
  },
  methods: {
    async beforeLeavingInvoiceLines() {
      const ref: any = this.$refs["step2"];
      if ((await ref.validate()) === false) {
        return false;
      }
      this.invoiceData.lines = ref.getUpdatedInvoiceLines();
      this.updateTotalVat();
      this.updateGrandTotal();
      return true;
    },
    validateStep(ref: string) {
      return (
        this.$refs[ref] as InstanceType<typeof ValidationObserver>
      ).validate();
    },
    updateInvoiceData(invoice: Invoice) {
      this.invoiceData = invoice;
    },
    onLineCreated(line: InvoiceLine) {
      this.invoiceData.lines.push({ ...line });
      this.updateTotalVat();
      this.updateGrandTotal();
    },
    onLineDeleted(lines: InvoiceLine[]) {
      this.invoiceData.lines = lines;
      this.updateTotalVat();
      this.updateGrandTotal();
    },
    updateGrandTotal() {
      const array = this.invoiceData.lines;
      const priceWithoutVatAndTaxes: currency = array.reduce(
        (accumulator: currency, current: InvoiceLine) => {
          return current.price.multiply(current.qty).add(accumulator);
        },
        currency(0)
      );
      this.invoiceData.priceWithoutVatAndTaxes = priceWithoutVatAndTaxes;
      const grandTotal = this.invoiceData.priceWithoutVatAndTaxes?.add(
        this.invoiceData.vat
      );
      this.invoiceData.grandTotal = grandTotal;
    },
    updateTotalVat() {
      const invoiceLines = this.invoiceData.lines;
      for (const invoiceLine of invoiceLines) {
        const subtotal = invoiceLine.price.multiply(invoiceLine.qty);
        invoiceLine.totalVat = subtotal.multiply(invoiceLine.vat).divide(100);
      }
      const totalVat = invoiceLines.reduce(
        (accumulator: currency, current: InvoiceLine) => {
          return current.totalVat.add(accumulator);
        },
        currency(0)
      );
      this.invoiceData.vat = totalVat;
    },
  },
});
